<template>
    <div class="forum_list">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <!-- 主体 -->
        <div class="main">
            <div class="left">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>{{ documentTitle }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="content">
                    <div><img src="../../assets/img/index/CXGheader.png" alt=""></div>
                    <div class="menuTab">
                        <div class="top">
                            <span v-for="(item, index) in menuTabList" :key="index" @click="jump(item)">{{ item.name }}</span>
                        </div>
                    </div>

                    <div class="footBottom">
                        <div class="left">
                            <div class="forumTitle">
                                <div style="font-size: 20px;color: #fff;">{{ documentTitle }}</div>
                            </div>
                            <div class="publicTop"></div>
                            <div class="list">
                                <ul>
                                    <li v-for="(item, index) in contentList" :key="index">
                                        <span class="title">{{ item.title }}</span>
                                        <div class="look">
                                            <span @click="toDetail(item)">查看</span>
                                        </div>
                                    </li>
                                </ul>
                                <el-empty class="empty" description="未找到您想要的" v-if="empty"></el-empty>
                                <el-pagination @current-change="currentChange"
                                  background
                                  :current-page="page"
                                  layout="prev, pager, next, jumper"
                                  next-text="下一页"
                                  prev-text="上一页"
                                  :total="total">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../../api/api'
import { decrypt } from '../../utils/decode'
import publicHeaders from '../../components/header.vue'
import foot from '../../components/foot.vue'
export default {
    name: 'forum_list',
    components: {
        publicHeaders,
        foot
    },
    data() {
        return {
            documentTitle: '',
            tree: [],
            menuTabList: [
                {
                    name: '首页',
                    title: '全国企业诚信建设示范基地',
                    url: '/developForum'
                },
                {
                    name: '通知文件',
                    title: '通知文件',
                    url: '/forum_detail'
                },
                {
                    name: '领导嘉宾',
                    title: '领导嘉宾',
                    url: '/forum_detail'
                },
                {
                    name: '活动议程',
                    title: '活动议程',
                    url: '/forum_detail'
                },
                {
                    name: '宣传报道',
                    title: '宣传报道',
                    url: '/forum_list'
                },
                {
                    name: '参会申请',
                    title: '参会申请',
                    url: '/forum_detail'
                },
                {
                    name: '往届回顾',
                    title: '往届回顾',
                    url: '/forum_list'
                },
            ],
            contentList: [
                // {
                //     title: '青春主场｜欢聚在成都'
                // },
                // {
                //     title: '有人用AI“拍”了一部《芭本海默》，堪比好莱坞原片'
                // },
                // {
                //     title: '长租公寓的风险应留意'
                // },
                // {
                //     title: '有人用AI“拍”了一部《芭本海默》，堪比好莱坞原片'
                // },
                // {
                //     title: '天气炎热食物容易变质，夏季警惕“危险”食物'
                // },
                // {
                //     title: '闽人智慧丨土楼不土，尽显科学与艺术之美'
                // },
                // {
                //     title: '经济学家高善文：25-59岁人口失业率创新低 简单讨论失业率非常不完整经济学家高善文：25-59岁人口失业率创新低 简单讨论失业率非常不完整'
                // },
                // {
                //     title: '智慧农业风起，中科原动力带机器人走进田间地头'
                // },
                // {
                //     title: '中国正能量，为奋进的中国吹响号角'
                // },
            ],
            page: 1,
            total: 0,
            empty: false,
            searchTitle: '',
            isSearch: false,
        }
    },
    created() {
        this.documentTitle = this.$route.query.documentTitle
        document.title = this.$route.query.documentTitle
        this.getTree()
    },
    mounted() {
    },
    methods: {// 获取分类
        getTree() {
            let _this = this
            this.tree = []
            let params = {}
            api.getTree().then(res => {
                let { data } = res
                // console.log(data);
                if (data.status == 200) {
                    _this.tree = data.data
                    
                    if (_this.$route.query.searchName != undefined) {
                        _this.searchTitle = _this.$route.query.searchName
                        _this.isSearch = true
                        _this.getList(_this.$route.query.searchName)
                    } else {
                        _this.searchTitle = ''
                        _this.isSearch = false
                        _this.getList()
                    }
                } else {
                    
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },
        
        // 获取列表
        getList(searchTitle) {
            let _this = this
            _this.contentList = []
            let params = {
                cateId: '',
                title: '',
                page: _this.page,
                size: 10,
            }
            _this.tree.forEach(element => {
                if (element.name == _this.documentTitle) {
                    params.cateId = element.id
                }
            });
            api.getList(params).then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    _this.contentList = data.data.data
                    _this.total = data.data.total
                    if (data.data.total == 0) {
                        _this.empty = true
                    } else {
                        _this.empty = false
                    }
                } else {
                    _this.empty = true
                }
            })
            .catch(error => {
                _this.empty = true
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 分页
        currentChange(val) {
            this.page = val;
            this.getList()
        },

        jump(item) {
            if (item.url != '') {
                this.$router.push({
                    path: item.url,
                    query: {
                        documentTitle: item.title
                    }
                })
                // let routeUrl = this.$router.resolve({
                //   path: item.url
                // });
                // // console.log(routeUrl);
                // window.open(routeUrl.href+ '?documentTitle=' + item.title, '_blank');
            }
        },

        // 查看详情
        toDetail(item) {
            // let routeUrl = this.$router.resolve({
            //   path: "/integrity_detail"
            // });
            let title = this.documentTitle + '详情'
            this.$router.push({
                name: 'integrity_detail',
                query: {
                    documentTitle: title,
                    id: item.id
                }
            })
            // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title + '&id=' + item.id, '_blank');
        }
    }
}
</script>

<style lang="less" scoped>
.forum_list {
    position: relative;
    padding-bottom: 140px;
    .main {
        width: 80%;
        padding: 15px 50px;
        margin: 0 auto;
        @media only screen and (min-width: 769px) {
            min-width: 1152px;
        }
        .left {
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
            .content {
                min-height: 600px;
                margin-top: 10px;
                .menuTab {
                    margin-top: 15px;
                    color: #134AA6;
                    padding: 0 235px;
                    background-color: #E8F1FF;
                    .top {
                        padding: 10px 0;
                        display: flex;
                        span {
                            flex: 1;
                            cursor: pointer;
                            text-align: center;
                        }
                        span:nth-of-type(n+2) {
                            border-left: 1px solid #98C8F8;
                        }
                    }
                }
                .publicity {
                    margin-top: 15px;
                    position: relative;
                    .text {
                        position: absolute;
                        bottom: -78px;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 1266px;
                        height: 154px;
                        border: 1px solid #1A68E8;
                        background-color: #fff;
                        padding: 20px;
                        color: #666;
                        line-height: 26px;
                    }
                }
                .footBottom {
                    min-height: 200px;
                    margin-top: 25px;
                    display: flex;
                    justify-content: space-between;
                    .left {
                        width: 77%;
                        border: 1px solid #5797FF;
                        position: relative;
                        .publicTop {
                            height: 46px;
                            border-bottom: 1px solid #85B2FF;
                            background: linear-gradient(to bottom, #EAF6FF, #ECF7FF, #DEF0FF, #E9F5FF, #F6FBFF);
                        }
                        .forumTitle {
                            position: absolute;
                            left: -1px;
                            top: -11px;
                            width: 175px;
                            height: 57px;
                            background: url('../../assets/img/index/forumTitle.png') no-repeat;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding-right: 10px;
                        }
                        .list {
                            position: relative;
                            padding: 0 20px 15px;
                            ul {
                                min-height: 640px;
                            }
                            .empty {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                            }
                            li {
                                border-bottom: 1px solid #E6E6E6;
                                display: flex;
                                justify-content: space-between;
                                padding: 25px 0 20px;
                                .title {
                                    display: inline-block;
                                    width: 940px;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                }
                                .look {
                                    span {
                                        border: 1px solid #1A68E8;
                                        padding: 5px 10px;
                                        color: #1A68E8;
                                        cursor: pointer;
                                    }
                                }
                            }
                            /deep/ .el-pagination {
                                display: flex;
                                justify-content: center;
                                margin-top: 20px;
                            }
                            /deep/ .el-pager li {
                                background: #fff;
                                border: 1px solid #ddd;
                                border-radius: 1px;
                                margin: 0;
                                height: 34px;
                                line-height: 34px;
                                width: 34px;
                            }
                            /deep/ .el-pager li:nth-of-type(n+2) {
                                border-left: none;
                            }
                            /deep/ .btn-next {
                                margin: 0;
                                height: 34px;
                                line-height: 34px;
                                padding: 0 15px;
                                display: flex;
                                align-items: center;
                                background: #fff;
                                border: 1px solid #ddd;
                                border-left: none;
                            }
                            /deep/ .btn-prev {
                                margin: 0;
                                height: 34px;
                                line-height: 34px;
                                padding: 0 15px;
                                display: flex;
                                align-items: center;
                                background: #fff;
                                border: 1px solid #ddd;
                                border-right: none;
                            }
                            /deep/ .el-pager li:not(.disabled).active {
                                background-color: #1A68E8;
                            }
                        }
                    }
                    .right {
                        width: 23%;
                    }
                }
            }
        }
    }
}
</style>
